import React from 'react';
import Icon from '../../../components/AppIcon';

const METRIC_CONFIG = [
  { key: 'survey_completion_rate', title: 'Survey Completion Rate', icon: 'CheckCircle', format: (v) => `${v}%`, description: 'Surveys completed vs initiated' },
  { key: 'average_valuation',      title: 'Average Valuation',      icon: 'DollarSign', format: (v) => `₹${Number(v).toLocaleString()}`, description: 'Mean property valuation amount' },
  { key: 'client_satisfaction',    title: 'Client Satisfaction',    icon: 'Star',        format: (v) => `${v}/5.0`, description: 'Average client rating score' },
  { key: 'monthly_revenue',        title: 'Monthly Revenue',        icon: 'TrendingUp',  format: (v) => `₹${Number(v).toLocaleString()}`, description: 'Total revenue this month' },
];

const MetricsOverview = ({ metrics }) => {
  if (!metrics) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 mb-8">
      {METRIC_CONFIG.map((config) => {
        const value = metrics[config.key] ?? 0;
        const change = config.key === 'monthly_revenue' ? metrics.revenue_change : null;
        const trend = change !== null ? (change >= 0 ? 'up' : 'down') : 'up';

        return (
          <div key={config.key} className="bg-card rounded-lg border border-border p-6 shadow-elevation-1">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center justify-center w-12 h-12 bg-primary/10 rounded-lg">
                <Icon name={config.icon} size={24} color="var(--color-primary)" />
              </div>
              {change !== null && (
                <div className={`flex items-center space-x-1 text-sm font-medium ${trend === 'up' ? 'text-success' : 'text-error'}`}>
                  <Icon name={trend === 'up' ? 'TrendingUp' : 'TrendingDown'} size={16} />
                  <span>{change >= 0 ? '+' : ''}{change}%</span>
                </div>
              )}
            </div>
            <div className="space-y-2">
              <h3 className="text-2xl font-bold text-foreground">{config.format(value)}</h3>
              <p className="text-sm font-medium text-foreground">{config.title}</p>
              <p className="text-xs text-muted-foreground">{config.description}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default MetricsOverview;
